import React, { Component } from 'react';
import { Input, Button, Icon, message, Form } from 'antd';

import { confirmLogin } from '../../common/fetch';
import { setCookie } from '../../common/utils';
import Wrapper from './style';

class VerifyCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDisable: true
        };
    }

    handleChange = (e) => {
        if (e.target.value) {
            this.setState({ isDisable: false });
        } else {
            this.setState({ isDisable: true });
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { getFieldValue } = this.props.form;
        const { history, location } = this.props;
        const code = getFieldValue('code');
        const body = { code };
        try {
            const res = await confirmLogin(body);
            setCookie('id_token', `Bearer ${res.data.token}`);
            if (location.state && location.state.project) {
                history.push(location.state.project);
                history.go(0);
            } else {
                history.go(0);
            }
        } catch (error) {
            message.error(error.data.message);
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Wrapper>
                <h3>Input Verification Code</h3>
                <div className="small-text">
                    <div>A unique code was sent to your email that is required to finish the login process.</div>
                    <div className="bold">Please input the code below to proceed.</div>
                </div>
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item>
                        {getFieldDecorator('code', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Please input your code!'
                                },
                            ]
                        })(
                            <Input
                                prefix={
                                    <Icon
                                        type="lock"
                                        style={{ color: '#42454D' }}
                                    />
                                }
                                placeholder='Input code'
                                onChange={this.handleChange}
                            />
                        )}
                    </Form.Item>
                    <div>
                        <Button
                            block
                            type="primary"
                            htmlType="submit"
                            disabled={this.state.isDisable}
                        >
                            Submit
                        </Button>
                    </div>
                </Form>
            </Wrapper>
        );
    }
}

const WrappedVerifyCode = Form.create({ name: 'VerifyCode_form' })(VerifyCode);

export default WrappedVerifyCode;
